import React from 'react';
import { UserSubscription } from '@/lib/db/services/subscriptionService';
import { Check } from 'lucide-react';
import { SubscriptionActivation } from './SubscriptionActivation';

interface SubscriptionFeaturesProps {
  subscription?: UserSubscription;
  userId?: string;
  onSubscriptionUpdate?: () => void;
}

export function SubscriptionFeatures({
  subscription,
  userId,
  onSubscriptionUpdate,
}: SubscriptionFeaturesProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h2 className="text-lg font-bold mb-4">Your Plan Features</h2>
      <ul className="space-y-3 mb-6">
        {subscription?.features.map((feature, index) => (
          <li key={index} className="flex items-start gap-3">
            <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
            <span className="text-gray-600">{feature}</span>
          </li>
        ))}
      </ul>

      {!subscription && userId && (
        <SubscriptionActivation
          userId={userId}
          onSuccess={onSubscriptionUpdate}
        />
      )}
    </div>
  );
}
